export const AVAILABLE_LANGUAGES = ["en-US","en-AU","fr-FR","pl-PL","es-ES"];
export const AVAILABLE_CURRENCIES = ["USD", "EUR", "GBP", "CAD", "PAB", "PLN", "ARS"];

export const ASSETS_PATH = document.location.port === "9005" ? "." : "/content/views/dashboard";

export const POST_MESSAGES = {
  setIframeLanguage: "SET_IFRAME_LANGUAGE"
};

export const AVAILABLE_VISUALIZERS = {
  bathroom: "bathroom",
  kitchen: "kitchen",
  fireplace: "fireplace",
  laundryroom: "laundryroom",
  leadform: "leadform"
}

export const VISUALIZER_TYPES = {
  bathroom: "bv",
  kitchen: "kv",
  fireplace: "fp",
  laundryroom: "lr",
}
